import axios from "../../axios/interceptor.js";
import Toast from "../../component/toastify/Index.jsx";

export const getBillingStatus = async (payload) => {
  try {
    const response = await axios.get("/customer/billing/getBillingStatus");
    if (response?.data?.isSuccess) {
      return response.data;
    } else {
      Toast(response?.data?.message, "error");
    }
  } catch (error) {
    Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
  }
};

export const getSubscription = async (payload) => {
  try {
    const response = await axios.post("/customer/billing/getSubscription", payload);
    if (response?.data?.isSuccess) {
      return response.data;
    } else {
      Toast(response?.data?.message, "error");
    }
  } catch (error) {
    Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
  }
};

export const getHistory = async (payload) => {
  try {
    const response = await axios.post("/customer/billing/getHistory", payload);
    if (response?.data?.isSuccess) {
      return response.data;
    } else {
      Toast(response?.data?.message, "error");
    }
  } catch (error) {
    Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
  }
};
